import { gql } from '@apollo/client';

export const UPLOAD_BILL_IMAGE = gql`
  mutation Flex_UploadBillImage($input: BillUploadInput!) {
    uploadBillImage(input: $input) {
      id
    }
  }
`;
